<template>
  <div class="product-shelf-teaser">
    <div class="product-shelf-teaser__product">
      <div
        class="product-shelf-teaser__product__image"
        v-if="product"
        :style="`background-image: url(https://storage.googleapis.com/emma-static/products/${product.img}_1200.jpg)`"
      />
      <span v-else class="product-shelf-teaser__product__empty">?</span>
    </div>
    <div class="badge badge-light product-shelf-teaser__amount" v-if="amount">{{ amount }}x in</div>
    <div class="product-shelf-teaser__arrow" v-else />
    <ShelfBadge :label="shelfSpaceId || '????'" class="product-shelf-teaser__shelf" />
  </div>
</template>

<script>
import ShelfBadge from '@/components/ShelfBadge'

export default {
  props: ['product', 'shelfSpaceId', 'amount'],
  components: { ShelfBadge }
}
</script>

<style lang="scss" scoped>
.product-shelf-teaser {
  display: flex;
  flex-direction: row;
  margin: 0 0 1rem;
  justify-content: space-between;
  align-items: center;

  &__product {
    border: 1px #ccc solid;
    width: 10rem;
    height: 10rem;
    border-radius: 5px;

    &__empty {
      display: inline-block;
      font-size: 2rem;
      width: 10rem;
      line-height: 10rem;
      text-align: center;
    }

    &__image {
      width: 8rem;
      height: 8rem;
      margin: 1rem;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center center;
    }
  }

  &__shelf {
    font-size: 2rem;
  }

  &__amount {
    font-size: 1.75rem;
  }

  &__arrow {
    width: 3rem;
    height: 3rem;
    background: url(../scss/img/arrow-right-circle.svg) center center no-repeat;
  }
}
</style>
